"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _dayjs = _interopRequireDefault(require("dayjs"));
var _dataQuery = require("@/api/dataQuery");
var _report = require("@/api/report");
var _default = exports.default = {
  data: function data() {
    return {
      resetReportLoading: false,
      homeDataPie: {
        coolingCapacityByHourMapList: {
          list1: [],
          list2: []
        }
      },
      switchChart: false,
      value: (0, _dayjs.default)().format("YYYY-MM"),
      isShow: true,
      show: true,
      checked: true,
      calendarData: [],
      haveData: [],
      monthList: [],
      listData: [],
      reportData: [],
      previewSrc: "",
      previewSrcOne: "",
      previewData: {},
      dialogVisible: false,
      reportLogoVisible: 1,
      // 判断今天是不是本月一号
      nowMonth: (0, _dayjs.default)().format('YYYY-MM-DD') == (0, _dayjs.default)().startOf('month').format('YYYY-MM-DD') ? (0, _dayjs.default)().subtract(1, 'month').format('YYYY-MM') : (0, _dayjs.default)().format('YYYY-MM'),
      dayActive: (0, _dayjs.default)().format("YYYY-MM-DD"),
      currentDay: (0, _dayjs.default)().format("YYYY-MM-DD"),
      monthData: (0, _dayjs.default)().format("YYYY-MM"),
      userInfo: {},
      firstChart: {
        xdata: [],
        gll: [],
        hdl: [],
        rdf: []
      },
      secondSbnh: [],
      secondFpg: {
        psd: "",
        dgsd: "",
        gfsd: ""
      },
      nxglObj: {
        dataTime: [],
        lj: [],
        nx: []
      },
      thirdGlsc: {
        data: [],
        xdata: []
      },
      fourthChart: {
        copData: [],
        ColdPrice: [],
        xdata: []
      },
      magnifyChart: {
        first: null,
        thirdly: null,
        fourth: null
      },
      pickerOptions0: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      pickerOptions1: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      historicalData: [],
      loading: false,
      colorType: '',
      echartfc: '',
      // 图表颜色
      echartLine: '',
      // 图表线颜色
      echartYLine: '',
      zoom: '',
      zoomrAtio: '',
      nhzbCount: 0
    };
  },
  watch: {
    value: function value(val) {
      this.monthData = (0, _dayjs.default)(val).format("YYYY");
    },
    monthData: function monthData(val) {
      this.dayActive = val;
      this.calendarData = [];
      this.getMonthWordYearListData();
    },
    nowMonth: function nowMonth() {
      this.getData();
      this.getFourth();
      this.getMonthWordYearListData();
      this.getMonthWordPreviewData((0, _dayjs.default)(this.nowMonth).format("YYYY-MM"));
      this.getDataQueryData();
    },
    "$store.state.project.colorType": function $storeStateProjectColorType() {
      this.colorType = this.$store.state.project.colorType;
      if (this.colorType == 'theme_jyh') {
        this.echartfc = '#fff';
        this.echartLine = '#29292d';
        this.echartYLine = '#333';
      } else if (this.colorType == 'theme_ytl') {
        this.echartfc = '#333';
        this.echartLine = '#333';
        this.echartYLine = '#ddd';
      } else {
        this.echartfc = '#333';
        this.echartLine = '#333';
        this.echartYLine = '#ddd';
      }
      this.getFirstChart();
      this.getSecondChartSbnh();
      this.getFourthChart();
      this.getLineCharts();
      // this.getThirdChart();
    }
  },
  computed: {
    installedCapacity: function installedCapacity() {
      return this.$store.state.project.projectInfo.installedCapacity;
    },
    isCurrentMonth: function isCurrentMonth() {
      if (this.nowMonth == (0, _dayjs.default)().format("YYYY-MM")) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted: function mounted() {
    this.colorType = this.$store.state.project.colorType;
    if (this.colorType == 'theme_jyh') {
      this.echartfc = '#fff';
      this.echartLine = '#29292d';
      this.echartYLine = '#333';
    } else if (this.colorType == 'theme_ytl') {
      this.echartfc = '#000';
      this.echartLine = '#333';
      this.echartYLine = '#ddd';
    } else {
      this.echartfc = '#000';
      this.echartLine = '#333';
      this.echartYLine = '#ddd';
    }
    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    }
    this.calendarData = [];
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    if (month == 1) {
      this.monthData = (parseInt(year) - 1).toString();
    } else {
      this.monthData = (0, _dayjs.default)().format("YYYY");
    }
    this.getData();
    this.getFourth();
    this.getMonthWordYearListData();
    this.getDataQueryData();
    this.getMonthWordPreviewData((0, _dayjs.default)(this.nowMonth).format("YYYY-MM"));
  },
  methods: {
    monthWordPreview: function monthWordPreview() {},
    handleClose: function handleClose() {
      var opens = document.getElementById("magnifyChart1");
      opens.style.display = "none";
    },
    initChart: function initChart(index) {
      var opens = document.getElementById("magnifyChart1");
      opens.style.display = "block";
      var lineCharts = this.$echarts.init(document.getElementById("magnifyChartData"));
      lineCharts.clear();
      if (index == 1) {
        lineCharts.setOption(this.magnifyChart.first);
      } else if (index == 3) {
        lineCharts.setOption(this.magnifyChart.thirdly);
      } else if (index == 4) {
        lineCharts.setOption(this.magnifyChart.fourth);
      }
    },
    getMonthWordPreviewData: function getMonthWordPreviewData(date) {
      var _this2 = this;
      this.show = true;
      var params = {
        dayTime: date,
        projectId: this.$store.state.project.projectInfo.id
      };
      (0, _report.monthProjectReportPreviewData)(params).then(function (res) {
        _this2.previewData = res;
        _this2.show = false;
      }).catch(function (err) {
        _this2.show = false;
        _this2.previewData = [];
      });
    },
    getData: function getData() {
      var _this3 = this;
      var firstTimeParams = this.nowMonth;
      //第一板块数据
      var params = {
        projectId: this.$store.state.project.projectInfo.id,
        dayReportDate: firstTimeParams + "-01 00:00:00"
      };
      (0, _report.getProjectDayReportByProjectIdOrGenerationListDate)(params).then(function (res) {
        _this3.firstChart.xdata = res.map(function (e) {
          return (0, _dayjs.default)(e.generationDate).format("MM-DD");
        });
        _this3.firstChart.gll = res.map(function (e) {
          return e.coolingCapacity;
        });
        _this3.firstChart.hdl = res.map(function (e) {
          return e.powerConsumption;
        });
        _this3.firstChart.rdf = res.map(function (e) {
          return e.electricityFee;
        });
        _this3.getFirstChart();
      });
      //第二板块数据
      var secondTimeParams = this.nowMonth;
      var secondParams = {
        timeType: 2,
        projectId: this.$store.state.project.projectInfo.id,
        dateTime: (0, _dayjs.default)(secondTimeParams).format("YYYY")
      };
      (0, _dataQuery.getProjectConsumptionPercentage)(secondParams).then(function (res) {
        if (res && res.length !== 0 && Object.values(res).length !== 0) {
          _this3.secondSbnh = [];
          for (var day in res) {
            if ((0, _dayjs.default)(day).format("MM/D") == (0, _dayjs.default)(_this3.nowMonth).format("MM/D")) {
              for (var data in res[day]) {
                switch (data) {
                  case "6":
                    _this3.secondSbnh.push({
                      value: res[day][data][1],
                      name: _this3.$t('report.zj'),
                      msg: res[day][data][0]
                    });
                    break;
                  case "4":
                    _this3.secondSbnh.push({
                      value: res[day][data][1],
                      name: _this3.$t('report.lqsb'),
                      msg: res[day][data][0]
                    });
                    break;
                  case "3":
                    _this3.secondSbnh.push({
                      value: res[day][data][1],
                      name: _this3.$t('report.ldsb'),
                      msg: res[day][data][0]
                    });
                    break;
                  case "5":
                    _this3.secondSbnh.push({
                      value: res[day][data][1],
                      name: _this3.$t('report.lqt'),
                      msg: res[day][data][0]
                    });
                    break;
                }
              }
              _this3.nhzbCount = 0;
              _this3.secondSbnh.map(function (m) {
                _this3.nhzbCount += m.msg;
              });
            }
          }
        }
        _this3.getSecondChartSbnh();
      });

      //板块二 峰平谷
      // getFpg(params).then((res) => {
      //   this.secondFpg.dgsd = res.dgsd;
      //   this.secondFpg.gfsd = res.gfsd;
      //   this.secondFpg.psd = res.psd;
      //   this.getSecondChartFpg();
      // });

      //板块三 供冷时长

      // getGlsc(params).then((res) => {
      //   this.thirdGlsc.xdata = res.map((e) => {
      //     return dayjs(e.dataTime).format("MM-DD");
      //   });
      //   this.thirdGlsc.data = res.map((e) => {
      //     return e.bootTime;
      //   });

      //   this.getThirdChart();
      // });
    },
    //板块四 冷价cop
    getFourth: function () {
      var _getFourth = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this4 = this;
        var firstTimeParams, params;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              firstTimeParams = this.nowMonth;
              params = {
                projectId: this.$store.state.project.projectInfo.id,
                dayReportDate: firstTimeParams + "-01 00:00:00"
              };
              this.nxglObj.dataTime = [];
              this.nxglObj.lj = [];
              this.nxglObj.nx = [];
              (0, _report.getMonthNxgl)(params).then(function (res) {
                var list = res;
                if (list.length > 0) {
                  for (var i = 0; i < list.length; i++) {
                    _this4.nxglObj.dataTime.push((0, _dayjs.default)(list[i].dataTime).format("MM-DD"));
                    ;
                    _this4.nxglObj.lj.push(list[i].lj);
                    _this4.nxglObj.nx.push(list[i].nx);
                  }
                  _this4.getFourthChart();
                }
              });
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getFourth() {
        return _getFourth.apply(this, arguments);
      }
      return getFourth;
    }(),
    handlePreview: function handlePreview() {
      var _this5 = this;
      this.dialogVisible = true;
      this.show = true;
      var params = {
        dayTime: this.nowMonth,
        projectId: this.$store.state.project.projectInfo.id
      };
      (0, _report.getMonthWordPreview)(params).then(function (res) {
        _this5.previewData = res;
        _this5.show = false;
      }).catch(function (err) {
        _this5.previewData = [];
        _this5.show = false;
      });
    },
    handleTime: function handleTime(val) {
      this.value = val;
    },
    formatterTime: function formatterTime(row) {
      return (0, _dayjs.default)(row.time).format("YYYY-MM-DD");
    },
    getMonthWordYearListData: function getMonthWordYearListData() {
      var _this6 = this;
      this.haveData = [];
      var params = {
        projectId: this.$store.state.project.projectInfo.id,
        dateTime: this.monthData
      };
      (0, _report.getMonthWordYearList)(params).then(function (res) {
        _this6.listData = res;
        _this6.haveData = res.map(function (e) {
          return {
            value: (0, _dayjs.default)(e.reportTime).format("YYYY-MM"),
            key: e.id
          };
        });
        res.forEach(function (data) {
          if ((0, _dayjs.default)(data.reportTime).format("YYYY-MM") == _this6.nowMonth) {
            _this6.previewSrc = data.reportFilePath;
          }
        });
      }).catch(function (error) {
        //console.log("处理逻辑出错:" + error);
      });
    },
    handlOneDown: function handlOneDown() {
      var _this7 = this;
      this.loading = true;
      if (this.previewSrc) {
        var link = document.createElement("a");
        link.href = this.previewSrc;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      setTimeout(function () {
        _this7.loading = false;
      }, 1000);
    },
    handleBatchDown: function handleBatchDown() {
      if (this.calendarData.length !== 0) {
        this.getMonthReportData();
      } else {
        this.$message.error("未选择下载月份");
      }
    },
    getMonthReportData: function getMonthReportData() {
      var _this8 = this;
      this.loading = true;
      var params = {
        monthWordIds: this.calendarData,
        projectId: this.$store.state.project.projectInfo.id
      };
      setTimeout(function () {
        _this8.loading = false;
      }, 2000);
      (0, _report.getMonthReport)(params).then(function (res) {
        var link = document.createElement("a");
        link.href = res;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    handleCheckAll: function handleCheckAll() {
      this.isShow = !this.isShow;
      if (!this.isShow) {
        this.calendarData = this.haveData;
      } else {
        this.calendarData = [];
      }
    },
    //绘制板块一柱状图
    getFirstChart: function getFirstChart() {
      var lineCharts = this.$echarts.init(document.getElementById("first"));
      lineCharts.clear();
      var option = {
        grid: {
          left: "12%",
          right: "4%",
          top: "22%",
          bottom: "20%" // 也可设置left和right设置距离来控制图表的大小
        },
        color: ["#5570c6", "#91cc76", "#fac858"],
        tooltip: {
          trigger: "axis",
          borderWidth: 0,
          textStyle: {
            fontSize: 14,
            lineHeight: 30
          },
          formatter: function formatter(param) {
            //  //console.log("param---" + JSON.stringify(param));
            var str = "";
            var d = '';
            param.forEach(function (data) {
              d = data.axisValue + '</br>';
              if (data.seriesName == "日电费") {
                str += "".concat(data.marker).concat(data.seriesName, ":").concat(data.data, "RM");
              } else {
                str += "".concat(data.marker).concat(data.seriesName, ":").concat(data.data, "kWh </br>");
              }
            });
            return d + str;
          }
        },
        title: {
          right: 10,
          top: 10,
          textStyle: {
            fontSize: 16,
            color: "#fff",
            fontWeight: 400
          }
        },
        dataZoom: {
          // 放大和缩放
          type: "inside"
        },
        textStyle: {
          fontSize: 14
        },
        legend: {
          type: "plain",
          orient: "horizontal",
          icon: "circle",
          show: true,
          textStyle: {
            fontSize: 14,
            lineHeight: 30,
            color: "#fff"
          },
          formatter: function formatter(param) {
            if (param == "日电费") {
              return "".concat(param, "-RM");
            }
            return "".concat(param, "-kWh");
          }
        },
        xAxis: {
          axisPointer: {
            type: "shadow"
          },
          type: "category",
          axisLabel: {
            //x轴文字的配置
            show: true,
            interval: 0,
            //使x轴文字显示全
            rotate: 90
          },
          data: this.firstChart.xdata
        },
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              color: this.echartYLine
              //type:'dashed'虚线
            }
          }
        },
        series: [{
          name: this.$t('report.gll'),
          data: this.firstChart.gll,
          type: "bar",
          lineStyle: {
            color: this.echartLine
          }
        }, {
          name: this.$t('report.hdl'),
          data: this.firstChart.hdl,
          type: "bar",
          lineStyle: {
            color: this.echartLine
          }
        }, {
          name: this.$t('report.rdf'),
          data: this.firstChart.rdf,
          type: "bar",
          lineStyle: {
            color: this.echartLine
          }
        }]
      };
      this.magnifyChart.first = option;
      lineCharts.setOption(option);
    },
    //绘制第二板块
    getSecondChartSbnh: function getSecondChartSbnh() {
      var lineCharts = this.$echarts.init(document.getElementById("second"));
      lineCharts.clear();
      var option = {
        tooltip: {
          trigger: "item",
          borderWidth: 0,
          textStyle: {
            fontSize: 14,
            lineHeight: 30
          },
          formatter: function formatter(param) {
            return "".concat(param.marker).concat(param.name, ":").concat(param.data.msg, "kWh \u5360\u6BD4: ").concat(param.value, "%  ");
          }
        },
        textStyle: {
          fontSize: 14
        },
        legend: {
          // type: "plain",
          bottom: 5,
          left: "center",
          textStyle: {
            fontSize: 14,
            color: "#fff",
            lineHeight: 30
          }
        },
        series: [{
          // bottom: "12%",
          type: "pie",
          radius: ["40%", "60%"],
          center: ["50%", "45%"],
          // radius: "66%",
          data: this.secondSbnh,
          color: ["#fac858", "#ed6666", "#5570c6", "#91cc76"],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          },
          label: {
            color: "#fff",
            formatter: function formatter(params) {
              return "".concat(params.name, "  ").concat(params.data.value, "%");
            }
          },
          itemStyle: {
            label: {
              show: true,
              formatter: function formatter(param) {
                return "".concat(param.name, ": ").concat(param.value, "%  ");
              }
            },
            labelLine: {
              show: true
            }
          }
        }],
        title: {
          text: this.nhzbCount.toFixed(1),
          subtext: "kWh",
          left: "center",
          top: "38%",
          textStyle: {
            color: "#fff"
          }
        }
      };
      lineCharts.setOption(option);
    },
    //绘制第二板块
    getSecondChartFpg: function getSecondChartFpg() {
      var lineCharts = this.$echarts.init(document.getElementById("second"));
      lineCharts.clear();
      var option = {
        color: ["#fbc858", "#91cc75", "#6db1f0", "#ff9274"],
        tooltip: {
          trigger: "item",
          borderWidth: 0,
          formatter: function formatter(params) {
            return "".concat(params.name, "<br />").concat(params.marker).concat(params.value, ", \u5360\u6BD4:").concat(params.percent, "%");
          },
          textStyle: {
            fontSize: 14,
            lineHeight: 30
          },
          padding: 15
        },
        series: [{
          type: "pie",
          radius: "50%",
          data: [{
            value: this.secondFpg.dgsd,
            name: "低谷时段"
          }, {
            value: this.secondFpg.gfsd,
            name: "高峰时段"
          }, {
            value: this.secondFpg.psd,
            name: "平时段"
          }],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }]
      };
      lineCharts.setOption(option);
    },
    getThirdChart: function getThirdChart() {
      var lineCharts = this.$echarts.init(document.getElementById("third"));
      lineCharts.clear();
      var option = {
        tooltip: {
          trigger: "axis",
          borderWidth: 0,
          textStyle: {
            fontSize: 14,
            lineHeight: 30
          },
          padding: 15,
          formatter: "{a0}:{c0}h"
        },
        dataZoom: {
          // 放大和缩放
          type: "inside"
        },
        legend: {
          type: "plain",
          orient: "horizontal",
          icon: "circle",
          show: true,
          textStyle: {
            fontSize: 14,
            lineHeight: 30,
            color: "#fff"
          }
        },
        xAxis: {
          axisPointer: {
            type: "shadow"
          },
          type: "category",
          axisLabel: {
            //x轴文字的配置
            show: true,
            interval: 0,
            //使x轴文字显示全
            rotate: 90
          },
          data: this.thirdGlsc.xdata
        },
        yAxis: {
          // name: "单位h",
          type: "value",
          axisLabel: {
            formatter: "{value} h"
          }
        },
        color: "#34aa44",
        series: [{
          name: "日供冷时长",
          data: this.thirdGlsc.data,
          type: "line"
        }]
      };
      this.magnifyChart.thirdly = option;
      lineCharts.setOption(option);
    },
    // 能效概览 图
    getFourthChart: function getFourthChart() {
      var lineCharts = this.$echarts.init(document.getElementById("fourth"));
      lineCharts.clear();
      var option = {
        tooltip: {
          trigger: "axis",
          borderWidth: 0,
          textStyle: {
            fontSize: 14,
            lineHeight: 30
          },
          padding: 15
        },
        grid: {
          bottom: 70,
          left: 50
        },
        dataZoom: {
          // 放大和缩放
          type: "inside"
        },
        textStyle: {
          fontSize: 14
        },
        legend: {
          data: [this.$t('report.lj'), this.$t('report.nx')],
          // top: 10,
          icon: "circle",
          textStyle: {
            fontSize: 14,
            lineHeight: 30,
            color: "#fff"
          }
        },
        xAxis: {
          axisPointer: {
            type: "shadow"
          },
          position: {
            bottom: 0
          },
          type: "category",
          axisTick: {
            show: false
          },
          boundaryGap: true,
          axisLabel: {
            show: true,
            interval: 0,
            rotate: 90
          },
          data: this.nxglObj.dataTime
        },
        yAxis: [{
          min: 0,
          type: "value",
          position: "left",
          name: this.$t('report.lj'),
          splitLine: {
            show: false
          }
        }, {
          type: "value",
          position: "right",
          name: this.$t('report.nx'),
          min: 0,
          splitLine: {
            show: false
          }
          // axisLabel: {
          //   formatter: "{value}%",
          // },
        }],
        series: [{
          name: this.$t('report.lj'),
          type: "bar",
          barWidth: "10",
          itemStyle: {
            color: "#34aa44",
            /// 折线点的颜色
            lineStyle: {
              color: "#34aa44" ///　折线的颜色
            }
          },
          data: this.nxglObj.lj
        }, {
          name: this.$t('report.nx'),
          type: "line",
          yAxisIndex: 1,
          symbol: "circle",
          symbolSize: 10,
          //折线点的大小
          itemStyle: {
            color: "#1665d8",
            /// 折线点的颜色
            lineStyle: {
              color: "#1665d8" ///　折线的颜色
            }
          },
          data: this.nxglObj.nx
        }]
      };
      this.magnifyChart.fourth = option;
      lineCharts.setOption(option);
    },
    // 数据统计
    getDataQueryData: function getDataQueryData() {
      var _this9 = this;
      var par = {
        timeType: 0,
        projectType: 0,
        projectId: this.$store.state.project.projectInfo.id,
        encryptType: 1,
        startTime: '',
        endTime: ''
      };
      var input = this.nowMonth;
      var arr = input.split('-');
      var maxDay = new Date(arr[0], arr[1], 0).getDate(); // 获取当月最后一日
      par.startTime = this.nowMonth + '-01';
      par.endTime = this.nowMonth + '-' + maxDay;
      (0, _dataQuery.getDataQuery)(par).then(function (res) {
        _this9.historicalData = res;
        _this9.getLineCharts();
      });
    },
    getLineCharts: function getLineCharts() {
      var _this10 = this;
      var lineCharts = this.$echarts.init(document.getElementById("line"));
      lineCharts.clear();
      var _this = this;
      var historicalData = [];
      _this.historicalData.map(function (e, i) {
        var list = [];
        list = e.data;
        list.map(function (ar) {
          ar[0] = ar[0].substr(5, 5);
        });
        var p = {
          type: "line",
          name: e.fieldMeaning,
          dimensions: [e.company // 如果此维度不想给出定义，则使用 null 即可
          ],
          symbol: "circle",
          showSymbol: false,
          data: list
        };
        historicalData.push(p);
      });
      var option = {
        tooltip: {
          confine: true,
          trigger: "axis",
          backgroundColor: "rgba(255,255,255,1)",
          extraCssText: "box-shadow:0 0 18px rgba(0,120,234,0.1);color:#333333",
          textStyle: {
            fontSize: 14,
            lineHeight: 34
          },
          padding: 15,
          formatter: function formatter(params) {
            var str = "";
            str = params[0].name;
            params.map(function (el) {
              str = str + "<br/><span class=\"color-circle\" style=\"background:".concat(el.color, ";\"></span> ").concat(el.seriesName, " : ").concat(el.value[1], "  ").concat(el.dimensionNames[0] === "x" ? "" : el.dimensionNames[0]);
            });
            return str;
          }
        },
        // color: _this.colors,
        legend: {
          icon: "circle",
          top: "2%",
          left: "14%",
          right: "3%",
          bottom: "5%",
          textStyle: {
            color: "#fff"
          }
          // type: "scroll",
        },
        grid: {
          left: "4%",
          right: "5%",
          top: "16%",
          bottom: "6%",
          containLabel: true
        },
        // dataZoom: [
        //   {
        //     type: "slider",
        //     height: 20,
        //     handleStyle: {
        //       borderColor: "#D2D0FF",
        //       shadowBlur: 4,
        //       shadowOffsetX: 1,
        //       shadowOffsetY: 1,
        //       shadowColor: "#e5e5e5",
        //     },
        //     show: true, // flase直接隐藏图形
        //     // xAxisIndex: [0],
        //     left: "4%", // 滚动条靠左侧的百分比
        //     bottom: 15,
        //     handleIcon:
        //       "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
        //     handleSize: "100%",
        //     start: 0, // 滚动条的起始位置
        //     end: 30, // 滚动条的截止位置（按比例分割你的柱状图x轴长度）
        //   },
        // ],
        dataZoom: {
          // 放大和缩放
          type: "inside"
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          splitLine: {
            show: false
          },
          // 去除网格线
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            interval: 0,
            rotate: 90
          },
          // axisLabel: {
          //   show: true,
          //   interval: 0,
          //   formatter: function (params) {
          //     if (params) {
          //       var newParamsName = "";
          //       var paramsNameNumber = params.length;
          //       var provideNumber = 10; // 一行显示几个字
          //       var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
          //       if (paramsNameNumber > provideNumber) {
          //         for (var p = 0; p < rowNumber; p++) {
          //           var tempStr = "";
          //           var start = p * provideNumber;
          //           var end = start + provideNumber;
          //           if (p === rowNumber - 1) {
          //             tempStr = params.substring(start, paramsNameNumber);
          //           } else {
          //             tempStr = params.substring(start, end) + "\n";
          //           }
          //           newParamsName += tempStr;
          //         }
          //       } else {
          //         newParamsName = params;
          //       }
          //       return newParamsName;
          //     }
          //   },
          //   textStyle: {
          //     color: "#bbbbbb", // 文字颜色
          //   },
          // },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              type: "solid"
            }
          }
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              type: "solid"
            }
          }
        },
        series: historicalData
      };
      this.magnifyChart.thirdly = option;
      lineCharts.setOption(option);
      this.$nextTick(function () {
        _this10.zoom = document.body.style.zoom;
        _this10.zoomrAtio = (1 / document.body.style.zoom).toFixed(2);
      });
    }
  }
};